import { request } from './common';

const host = window.configs.IMAGE_HOST;
const fieldKey = 'file';

export function uploadImage(file, withId?) {
  const url = withId ? `${host}/${withId}` : host;

  const formData = new FormData();
  formData.append(fieldKey, file);

  return request(url, {
    method: 'POST',
    body: formData,
  });
}

export function copyImage(id) {
  const formData = new FormData();
  formData.append(fieldKey, `${host}/${id}`);

  return request(host, {
    method: 'POST',
    body: formData,
  });
}

export const ALLOWED_IMAGE_MIMETYPES = ['image/jpeg', 'image/png', 'image/svg+xml'];
